import { Extension } from '@tiptap/react';
import { type Node as PmNode } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

/** Tài liệu chỉ có một khối chữ rỗng — trạng thái "chưa gõ gì", cùng nghĩa với `editor.isEmpty`. */
export function isEmptyDoc(doc: PmNode): boolean {
  const first = doc.firstChild;
  return doc.childCount === 1 && first !== null && first.isTextblock && first.content.size === 0;
}

/**
 * Gắn `data-empty` lên ô soạn khi tài liệu rỗng — dòng gợi ý (`data-placeholder`)
 * chỉ hiện theo cờ này (`.rich-text-content[data-empty]::before`).
 *
 * Trước đây CSS **đoán** ô trống từ hình dạng DOM: `:has(> p:only-child >
 * br:only-child)`. `:only-child` chỉ đếm phần tử, bỏ qua chữ, nên một đoạn có
 * chữ và **một** lần xuống dòng mềm (Shift+Enter, hay mô tả cũ có xuống dòng)
 * — `<p>dòng 1<br>dòng 2</p>` — cũng khớp, và dòng gợi ý hiện đè lên chữ đã gõ
 * (người dùng báo 2026-10-13). Hỏi thẳng tài liệu thì không còn gì để đoán.
 *
 * `props.attributes` dạng hàm của ProseMirror: tính lại sau mỗi giao dịch, gộp
 * với thuộc tính của `editorProps` (Tiptap trải `editorProps.attributes` thành
 * object nên không nhận hàm ở đó).
 */
export const EmptyDocFlag = Extension.create({
  name: 'emptyDocFlag',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          attributes: (state): Record<string, string> =>
            isEmptyDoc(state.doc) ? { 'data-empty': '' } : {},
        },
      }),
    ];
  },
});
